var current = {
    compile: function(template) {
        return template;
    }
};

var TemplateService = function TemplateService () {};

TemplateService.register = function register (userImplementation) {
    current = userImplementation;
};

TemplateService.compile = function compile (template) {
    return current.compile(template);
};

export default TemplateService;


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-ooxml/dist/es/services/template-service.js
// module id = ../../../../@progress/kendo-ooxml/dist/es/services/template-service.js
// module chunks = vendor